import {MutationTree} from "vuex";
import {DataPropertyProfileState, DataPropertyProfile} from "./model";

const mutations: MutationTree<DataPropertyProfileState> = {
  setDataPropertyProfiles(state, dataPropertyProfiles: DataPropertyProfile[]) {
    state.dataPropertyProfiles = dataPropertyProfiles;
  },
  addDataPropertyProfile(state, dataPropertyProfile: DataPropertyProfile) {
    state.dataPropertyProfiles.push(dataPropertyProfile);
  },
  updateDataPropertyProfile(state, dataPropertyProfile: DataPropertyProfile) {
    const c = state.dataPropertyProfiles.find(c => c.id === dataPropertyProfile.id);
    Object.assign(c, dataPropertyProfile);
  },
  deleteDataPropertyProfile(state, id: string) {
    state.dataPropertyProfiles = state.dataPropertyProfiles.filter(dataPropertyProfile => dataPropertyProfile.id !== id);
  }
}

export default mutations;
